var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-logo hidden-md-and-up"},[_c('div',{staticClass:"logo text-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/img/login-screens/Logo.png","alt":"nutron logo"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }